import { call, put, select } from 'redux-saga/effects';
import { populateCountriesList } from '@actions/countries';
import { getCountriesList } from '@services/countriesResource';
import { tokenSelector, selectUserId } from '@selectors/authentication';
import { displaySnackBar } from '@actions/snackbar';

export function* getCountriesListSaga(action) {
  try {
    const token = yield select(tokenSelector);
    const { data } = yield call(getCountriesList, token);
    yield put(populateCountriesList(data));
  } catch (err) {
    yield put(
      displaySnackBar(false, err.message || 'Error when fetching countries list.'),
    );
  }
}



// WEBPACK FOOTER //
// ./redux/sagas/countries.js